import { render, staticRenderFns } from "./IcoArrowDown.vue?vue&type=template&id=cbcb626c"
import script from "./IcoArrowDown.vue?vue&type=script&lang=js"
export * from "./IcoArrowDown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports